import { render, staticRenderFns } from "./VMask.vue?vue&type=template&id=5fa38bc8&scoped=true&"
import script from "./VMask.vue?vue&type=script&lang=js&"
export * from "./VMask.vue?vue&type=script&lang=js&"
import style0 from "./VMask.vue?vue&type=style&index=0&id=5fa38bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa38bc8",
  null
  
)

export default component.exports